export default [
  {
    path: '/properties',
    name: 'PropertiesList',
    component: () => import('pages/properties/PropertiesList.vue')
  },
  {
    path: 'properties/new',
    name: 'PropertiesCreate',
    component: () => import('pages/properties/PropertiesForm.vue')
  },
  {
    path: '/properties/:id/edit',
    name: 'PropertiesEdit',
    component: () => import('pages/properties/PropertiesForm.vue')
  }
]
